import menuApi from "@/api/menu";
export default {
  methods: {
    async setLocalMenu() {
      const { data } = await menuApi.getMenu();
      if (data.success) {
        localStorage.setItem("allMenu", JSON.stringify(data.data));
      }
    }
  }
};
